module.exports = __webpack_public_path__ + "img/pro_night_3.d4135adb.jpg";